import type { MailboxInfo } from 'owa-client-types';
import { type CopilotExperimentKeys, CopilotExperimentStorageKey } from './copilotExperimentKeys';
import { getCopilotExperimentFromLocalStorage } from './copilotExperimentLocalStorage';

/**
 * Retrieves a custom copilot experiment prompt based on the provided experiment ID and mailbox information.
 */
export function getCustomCopilotExperiment(
    experimentId: CopilotExperimentKeys,
    mailboxInfo: MailboxInfo
): string | undefined {
    const promptKey =
        getCopilotExperimentFromLocalStorage(
            CopilotExperimentStorageKey.Scenarios,
            mailboxInfo
        ).get(experimentId) || '';

    return getCopilotExperimentFromLocalStorage(
        CopilotExperimentStorageKey.Prompts,
        mailboxInfo
    ).get(promptKey);
}
